import React, { useCallback, useContext, useMemo, useState } from "react";
import { errors } from "store/errors";

const ErrorsContext = React.createContext(null);

export const ErrorsProvider = ({children}) => {
    
    const [currentErrors, setCurrentErrors] = useState(new Set());

    const setError = useCallback((err) => {
        setCurrentErrors(prev => {
            const next = new Set(prev);
            next.add(err);
            return next;
        });
    }, []);

    const unsetError = useCallback((err, force = false) => {
        const error = errors[err];
        if(error && error.autoUnset && force === false) return;
        setCurrentErrors(prev => {
            const next = new Set(prev);
            next.delete(err);
            return next;
        });
    }, []);

    const clearErrors = useCallback(() => {
        setCurrentErrors(() => new Set());
    }, []);

    const value = useMemo(() => ({
        currentErrors,
        setError,
        unsetError,
        clearErrors
    }), [currentErrors, setError, unsetError, clearErrors]);

    return (
        <ErrorsContext.Provider value={value}>
            {children}
        </ErrorsContext.Provider>
    )
}

export const useErrors = () => {
    const context = useContext(ErrorsContext);

    if (!context) {
        throw new Error("useErrors must be used within ErrorsProvider");
    }

    return context;
}